import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IntegratedAdmissionWizardComponent } from "./integrated-admission-wizard/integrated-admission-wizard.component";
import { IntegratedAdmissionPatientComponent } from "./integrated-admission-patient/integrated-admission-patient.component";
import { IntegratedAdmissionAppointmentComponent } from "./integrated-admission-appointment/integrated-admission-appointment.component";
import { IntegratedRegularAdmissionWizardComponent } from "./integrated-regular-admission-wizard/integrated-regular-admission-wizard.component";
import { IntegratedExtraordinaryAdmissionWizardComponent } from "./integrated-extraordinary-admission-wizard/integrated-extraordinary-admission-wizard.component";
import { IntegratedPreAdmissionWizardComponent } from "./integrated-pre-admission-wizard/integrated-pre-admission-wizard.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppMaterialModule } from "src/app/app.material.module";
import { ControlsModule } from "../controls/controls.module";
import { SharedModule } from "../shared.module";
import { IntegratedAdmissionAppointmentListComponent } from "./integrated-admission-appointment-list/integrated-admission-appointment-list.component";
import { IntegratedAdmissionAppointmentObservationComponent } from "./integrated-admission-appointment/integrated-admission-appointment-observation/integrated-admission-appointment-observation.component";
import { IntegratedAdmissionAppointmentScannComponent } from "./integrated-admission-appointment/integrated-admission-appointment-scann/integrated-admission-appointment-scann.component";
import { IntegratedAdmissionAppointmentValidationComponent } from "./integrated-admission-appointment/integrated-admission-appointment-validation/integrated-admission-appointment-validation.component";
import { IntegratedAdmissionAppointmentPlanComponent } from "./integrated-admission-appointment/integrated-admission-appointment-plan/integrated-admission-appointment-plan.component";
import { IntegratedAdmissionAppointmentValorizationComponent } from "./integrated-admission-appointment/integrated-admission-appointment-valorization/integrated-admission-appointment-valorization.component";
import { IntegratedAdmissionAppointmentDocumentationComponent } from "./integrated-admission-appointment/integrated-admission-appointment-documentation/integrated-admission-appointment-documentation.component";
import { IntegratedAdmissionOperationComponent } from "./integrated-admission-operation/integrated-admission-operation.component";
import { IntegratedReceptionAdmissionSearchComponent } from "./integrated-reception-admission-search/integrated-reception-admission-search.component";
import { IntegratedReceptionAdmissionFilterComponent } from "./integrated-reception-admission-filter/integrated-reception-admission-filter.component";
import { PatientAutocompleteModule } from "../autocomplete/patient/patient-autocomplete.module";
import { IntegratedAdmissionInvoiceComponent } from "./integrated-admission-invoice/integrated-admission-invoice.component";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { IntegratedAdmissionControlWizardComponent } from "./integrated-admission-control-wizard/integrated-admission-control-wizard.component";
import { IntegratedAdmissionOperationDialogComponent } from "./integrated-admission-operation-dialog/integrated-admission-operation-dialog.component";
import { IntegratedAdmissionAppointmentValidationDialogComponent } from "./integrated-admission-appointment/integrated-admission-appointment-validation/integrated-admission-appointment-validation-dialog/integrated-admission-appointment-validation-dialog.component";
import { PatientPhoneFormatControlDialogComponent } from './integrated-admission-patient/patient-phone-format-control-dialog/patient-phone-format-control-dialog.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    IntegratedAdmissionWizardComponent,
    IntegratedAdmissionPatientComponent,
    IntegratedAdmissionAppointmentComponent,
    IntegratedRegularAdmissionWizardComponent,
    IntegratedPreAdmissionWizardComponent,
    IntegratedExtraordinaryAdmissionWizardComponent,
    IntegratedAdmissionAppointmentListComponent,
    IntegratedAdmissionAppointmentObservationComponent,
    IntegratedAdmissionAppointmentScannComponent,
    IntegratedAdmissionAppointmentValidationComponent,
    IntegratedAdmissionAppointmentPlanComponent,
    IntegratedAdmissionAppointmentValorizationComponent,
    IntegratedAdmissionAppointmentDocumentationComponent,
    IntegratedAdmissionOperationComponent,
    IntegratedReceptionAdmissionSearchComponent,
    IntegratedReceptionAdmissionFilterComponent,
    IntegratedAdmissionInvoiceComponent,
    IntegratedAdmissionControlWizardComponent,
    IntegratedAdmissionOperationDialogComponent,
    IntegratedAdmissionAppointmentValidationDialogComponent,
    PatientPhoneFormatControlDialogComponent,
  ],
  imports: [
    NgxMaskModule.forRoot(),
    CommonModule,
    AppMaterialModule,
    ControlsModule,
    SharedModule,
    ReactiveFormsModule,
    PatientAutocompleteModule,
    FormsModule
  ],
  exports: [IntegratedExtraordinaryAdmissionWizardComponent],
  entryComponents: [
    IntegratedAdmissionOperationDialogComponent,
    IntegratedAdmissionAppointmentValidationDialogComponent,
    PatientPhoneFormatControlDialogComponent
  ],
})
export class IntegratedAdmissionModule {}
